// Create Shopify Token
export const CREATE_SHOPIFY_TOKEN_REQUEST = 'CREATE_SHOPIFY_TOKEN_REQUEST';
export const CREATE_SHOPIFY_TOKEN_DONE = 'CREATE_SHOPIFY_TOKEN_DONE';
export const CREATE_SHOPIFY_TOKEN_FAILED = 'CREATE_SHOPIFY_TOKEN_FAILED';
export const CREATE_SHOPIFY_TOKEN_RESET = 'CREATE_SHOPIFY_TOKEN_RESET';